import { Tag } from "antd";
import React, { useState, useMemo } from "react";
import { $t } from "~/i18n.js";

import {
  Icon,
  landing,
  start,
  vak_kwart,
  vak_open,
} from "~/components/icon/icon.jsx";

import { LoadingOutlined } from "@ant-design/icons";
import { Badge } from "antd";
import { useSelector } from "react-redux";
import "./kistStatus.css";
import { KistStatusHangarModal } from "./KistStatusHangarModal.jsx";
import { KistStatusQueueModal } from "./KistStatusQueueModal.jsx";

const statusCheck = {
  available: { icon: vak_open },
  in_grid: { icon: vak_kwart },
  assigned: { icon: start, viewBox: "0 0 1400 1024" },
  in_air: { icon: landing, viewBox: "0 0 1100 1024" },
};

const RenderKistStatus = ({ kist, activeFlightKistID, openKist }) => {
  const [loading, setLoading] = useState(false);
  const active = activeFlightKistID && kist.id === activeFlightKistID;
  const count = kist.active_flights?.length - 1
  return (
    <div
      className="clickable"
      style={{ paddingTop: 7 }}
      onClick={async () => {
        if (!loading) {
          setLoading(true);
          await openKist({ kist });
          setLoading(false);
        }
      }}
    >
      <Badge count={count >= 1 ? count : 0} size="small">
        <Tag
          style={{ fontSize: 14, padding: "15px 12px" }}
          className="kist"
          color={active ? "orange" : "geekblue"}
        >
          {kist.callsign}
          {loading ? (
            <LoadingOutlined  style={{ marginLeft: 4 }} />
          ) : (
            <Icon {...statusCheck[kist.status]} style={{ marginLeft: 4 }} />
          )}
        </Tag>
      </Badge>
    </div>
  );
};

export const SectionKistStatus = ({
  activeFlightKistID,
  createNewFlightWithKist, 
  openFlightUUID,
  is_today,
  updateFlight
}) => {
  const [showOtherKistModal, openOtherKistModal] = useState(false);
  const [showQueueModal, setShowQueueModal] = useState(false);
  const [selectedKist, setSelectedKist] = useState(null);

  const { kistStatus } = useSelector((state) => state.flights);

  if (!kistStatus) return null;

  const ingezette_kisten = useMemo(() => {
    return kistStatus.filter(kist => kist.status !== "hangaar");
  }, [kistStatus]);

  const triggerOpenKist = async ({ kist }) => {
    if (kist.status === 'available') {
      return createNewFlightWithKist({ kist });
    } else {
      // Open queue modal for kists with active flights
      setSelectedKist(kist);
      setShowQueueModal(true);
    }
  }

  return (
    <div className="kistStatus row" style={{ gap: 12 }}>
      <KistStatusHangarModal
        open={showOtherKistModal}
        onClose={() => openOtherKistModal(false)}
        onSelect={createNewFlightWithKist}
        is_today={is_today}
      />
      
      <KistStatusQueueModal
        open={showQueueModal}
        onClose={() => setShowQueueModal(false)}
        kist={selectedKist}
        createNewFlightWithKist={createNewFlightWithKist}
        openFlightUUID={openFlightUUID}
        updateFlight={updateFlight}
      />

      {ingezette_kisten.map((kist, key) => (
        <RenderKistStatus
          key={key}
          kist={kist}
          activeFlightKistID={activeFlightKistID}
          openKist={triggerOpenKist}
        />
      ))}

      <Tag
        style={{ marginTop: 7, fontSize: 15, padding: "14px 12px" }}
        className="kist clickable"
        onClick={() => openOtherKistModal(true)}
      >
        {ingezette_kisten.length > 0
          ? "+ " + $t("andere kist")
          : $t("selecteer kist")}
      </Tag>
    </div>
  );
};
